<template>
  <b-nav-item-dropdown
    right
    toggle-class="d-flex align-items-center dropdown-user-link"
    class="dropdown-user"
  >
    <template
      v-if="loggedIn && userData"
      #button-content
    >
      <b-avatar
        size="40"
        :src="getAvatar()"
        variant="light-primary"
        :text="avatarText(userData.full_name)"
        :badge="hasNewUpdate"
        class="badge-minimal"
        badge-variant="success"
      >
        <feather-icon
          v-if="defaultAvatar(userData.avatar) === ''"
          icon="UserIcon"
          size="22"
        />
      </b-avatar>
    </template>
    <slot
      name="dropdownItemFirst"
      :user-data="userData"
    />
    <b-dropdown-item
      :to="{ name: 'account-setting' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="16"
        icon="UserIcon"
        class="mr-50"
      />
      <span>{{ $t('Profile') }}</span>
    </b-dropdown-item>
    <b-dropdown-divider />
    <b-dropdown-item
      link-class="d-flex align-items-center"
      @click="logout"
    >
      <feather-icon
        size="16"
        icon="LogOutIcon"
        class="mr-50"
      />
      <span>{{ $t('Logout') }}</span>
    </b-dropdown-item>
    <slot name="dropdownItemLast" />
  </b-nav-item-dropdown>
</template>

<script>
import {
  BNavItemDropdown, BDropdownItem, BDropdownDivider, BAvatar, BButton,
} from 'bootstrap-vue'
import { defaultAvatar } from '@/@core/utils/utils'
import { avatarText } from '@core/utils/filter'
import { mapState } from 'vuex'
import useJwt from '@/auth/jwt/useJwt'

export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
    BButton,
  },
  data() {
    return {
      avatarText,
      hasNewUpdate: false,
      defaultAvatar,
    }
  },

  computed: {
    // mix the getters into computed with object spread operator
    ...mapState({
      loggedIn: state => state.auth.loggedIn,
      userData: state => state.auth.user
      ,
    }),
  },
  methods: {
    logout() {
      useJwt
        .logout()
        .then(response => {
          if (response.status === 200) {
            // clear auth data
            useJwt.clearAuthData();

            // Redirect to login page
            this.$router.push({ name: 'auth-login' })
          }
        })
    },
    getAvatar() {
      return (this.userData && this.userData.avatar) ? this.userData.avatar : this.avarDefault;
    },
    showModalConfigPageHome() {
      this.$bvModal.show('showConfigPageHome');
    },
  },
  setup() {
    const avarDefault = '/logo-home.png';

    return {
      avarDefault,
    }
  },
}
</script>
<style>
.rounded-circle {
  border-radius: 4px;
}
</style>
